import React, { Component } from "react";
import { connect } from "react-redux";
import {
  removeFromCart,
  incrementToCart,
  decreaseToCart,
} from "../../../../store/actions/cartActions";

class Cartsidebar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      grandTotal: "",
      toggle: false,
      addedMessage: false, 
      showConfirmationModal: false,
    };
  }

  componentDidUpdate(prevProps) {

    if (prevProps.cartItems.length < this.props.cartItems.length) {
      this.setState({ addedMessage: true });
      setTimeout(() => {
        this.setState({ addedMessage: false }); // Hide message after 3 seconds
      }, 1500);
    }
  }

  handleHide = () => {
    this.setState({ toggle: !this.state.toggle });
  };

  handleRemoveVariant = (productId, id) => {
    this.props.removeFromCart(productId, id);
  };

  handleRemoveProduct = (productId) => {
    this.props.removeFromCart(productId, null); // Pass null to indicate removal of the entire product
  };

  handleCheckout = () => {
    if (this.props.cartItems.length > 0) {
      this.setState({ showConfirmationModal: true }); // Show confirmation popup
    }
  };
  handleAgree = () => {
    this.setState({ showConfirmationModal: false }, () => {
      window.location.href = "/checkout";
    });
  };

  handleCancel = () => {
    this.setState({ showConfirmationModal: false });
  };

  calculateSubTotal = () => {
    return this.props.cartItems.reduce((sum, item) => {
      if (Array.isArray(item.selectedVariants)) {
        return (
          sum +
          item.selectedVariants.reduce((variantSum, variant) => {
            return (
              variantSum +
              (typeof variant.price === "number" ? variant.price : 0)
            );
          }, 0)
        );
      }
      return sum;
    }, 0);
  };

  render() {
    const { cartItems } = this.props;
    const subTotal = this.calculateSubTotal();
    const deliveryCharges = subTotal * 0.0; // No additional charges
    let total = subTotal + deliveryCharges;
    let discount = 0;

    // Apply a 10% discount if the total cart value is more than ₹200
    if (total > 200) {
      discount = total * 0.1;
      total = total - discount;
    }

    return (
      <div>
        <span data-toggle="offcanvas" className="btn btn-link border-none">
          <i className="mdi mdi-cart" />{" "}
          <small className="cart-value">({cartItems.length})</small>
        </span>

       {this.state.addedMessage && (
  <div
    style={{
      position: "fixed",
      top: "20px",
      right: "20px",
      zIndex: 9999,
      background: "linear-gradient(135deg, #32CD32, #28a745)",
      color: "white",
      padding: "12px 20px",
      borderRadius: "8px",
      boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
      display: "flex",
      alignItems: "center",
      fontSize: "16px",
      fontWeight: 500,
      animation: "fadeSlideIn 0.3s ease-out",
    }}
  >
    <i
      className="mdi mdi-check-circle"
      style={{ marginRight: "10px", fontSize: "20px" }}
    ></i>
    Item has been added to the cart!
  </div>
)}


        <div className="cart-sidebar">
          <div className="bs-canvas-header side-cart-header p-3 ">
            <div className="d-inline-block main-cart-title">
              My Cart <span>({cartItems.length} Items)</span>
            </div>
            <button
              type="button"
              className="bs-canvas-close close"
              data-toggle="offcanvas"
            >
              <i className="mdi mdi-close"></i>
            </button>
          </div>
          <div className="cart-sidebar-body">
            <div
              className="discount-info"
              style={{
                background: "linear-gradient(90deg, #e0ffe0 0%, #d0f0c0 100%)",
                color: "#237804",
                fontWeight: "600",
                padding: "16px",
                textAlign: "center",
                border: "2px solid #b7eb8f",
                borderRadius: "12px",
                margin: "16px",
                fontSize: "17px",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                animation: "pulse 1.5s infinite",
              }}
            >
              🛍️ <strong>Exclusive Offer:</strong> Get{" "}
              <span style={{ color: "#fa541c" }}>10% OFF</span> when your cart
              total exceeds <strong>₹200</strong>!
            </div>

            {/* <div
              className="payment-alert"
              style={{
                color: "blue",
                fontWeight: "bold",
                padding: "10px",
                textAlign: "center",
              }}
            >
              Kindly do not make multiple payments. If you have already made the
              payment, and the design did not download, don't purchase same
              design again. Kindly reach out to us on Whatsapp. No
              <br />
              Refunds/Replacements will be issued to any of the purchased design
              products.
            </div> */}
            {cartItems.length > 0 ? (
              cartItems.map((item) => (
                <div className="cart-item" key={item.id}>
                  <div className="cart-product-img">
                    <img
                      crossOrigin="anonymous"
                      className="img-fluid"
                      src={item.photo}
                      alt={item.name}
                    />
                  </div>
                  <div className="cart-text">
                    <h4>
                      {item.name}
                      <i
                        className="mdi mdi-delete text-danger cursor-pointer"
                        onClick={() => this.handleRemoveProduct(item.id)}
                        style={{ cursor: "pointer", fontSize: "1.5rem" }}
                      />
                    </h4>
                    <div className="cart-radio">
                      {item.selectedVariants &&
                      item.selectedVariants.length > 0 ? (
                        item.selectedVariants.map((variant) => (
                          <div
                            key={variant.id}
                            className="d-flex align-items-center justify-content-between"
                          >
                            <span>
                              {variant.name} (₹{variant.price})
                            </span>
                            <i
                              className="mdi mdi-close-circle text-danger cursor-pointer"
                              onClick={() =>
                                this.handleRemoveVariant(item.id, variant.id)
                              }
                              style={{ cursor: "pointer" }}
                            />
                          </div>
                        ))
                      ) : (
                        <p>No variants selected</p>
                      )}
                    </div>
                    {item.selectedVariants &&
                      item.selectedVariants.length > 0 && (
                        <div className="qty-group">
                          <div className="cart-item-price">
                            &#x20B9;
                            {item.selectedVariants.reduce(
                              (acc, variant) => acc + variant.price,
                              0
                            )}
                          </div>
                        </div>
                      )}
                  </div>
                </div>
              ))
            ) : (
              <div
                style={{
                  textAlign: "center",
                  color: "#721c24",
                  backgroundColor: "#f8d7da",
                  fontWeight: "bold",
                  padding: "20px",
                  fontSize: "18px",
                  borderRadius: "10px",
                  margin: "20px",
                  border: "2px solid #f5c6cb",
                }}
              >
                <i
                  className="mdi mdi-cart-off"
                  style={{
                    fontSize: "28px",
                    display: "block",
                    marginBottom: "10px",
                  }}
                ></i>
                Your Cart is Empty!
              </div>
            )}
          </div>
          <div className="cart-sidebar-footer">
            <div className="cart-store-details">
              <p>
                Sub Total{" "}
                <strong className="float-right">
                  &#x20B9;{subTotal.toFixed(2)}
                </strong>
              </p>
              {discount > 0 && (
                <p>
                  Discount (10%){" "}
                  <strong className="float-right text-success">
                    -&#x20B9;{discount.toFixed(2)}
                  </strong>
                </p>
              )}
              <p>
                Total{" "}
                <strong className="float-right">
                  &#x20B9;{total.toFixed(2)}
                </strong>
              </p>
            </div>
            <button
              className="btn btn-secondary btn-lg btn-block text-left"
              type="button"
              onClick={this.handleCheckout} 
              disabled={cartItems.length === 0}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "10px",
                fontSize: "16px", 
                overflow: "hidden",
                marginTop: "20px",
              }}
            >
              <span className="float-left" style={{ whiteSpace: "nowrap" }}>
                <i className="mdi mdi-cart-outline" />
                Proceed to Checkout
              </span>
              <span className="float-right" style={{ whiteSpace: "nowrap" }}>
                <strong>&#x20B9;{total.toFixed(2)}</strong>
                <span className="mdi mdi-chevron-right" />
              </span>
            </button>
          </div>
        </div>
        {/* Confirmation Modal */}
        {this.state.showConfirmationModal && (
          <div
            className="modal-backdrop"
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              backgroundColor: "rgba(0,0,0,0.6)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 9999,
              padding: "20px",
              boxSizing: "border-box",
            }}
          >
            <div
              style={{
                background: "#fff",
                borderRadius: "12px",
                width: "100%",
                maxWidth: "500px",
                maxHeight: "90vh",
                overflowY: "auto",
                boxShadow: "0 8px 20px rgba(0,0,0,0.3)",
                padding: "20px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
              }}
            >
              <div style={{ overflowY: "auto" }}>
                <h4
                  style={{
                    marginBottom: "15px",
                    fontWeight: "600",
                    color: "#333",
                  }}
                >
                  Please Read Before Checkout
                </h4>
                <p style={{ fontSize: "15px", color: "#444" }}>
                  The purchased products will be available in downloads. If you
                  cannot find them in your downloads, please report the issue
                  via WhatsApp. Do not purchase the same products again.{" "}
                  <b>
                    No refunds will be issued for any digital goods purchased.
                  </b>
                </p>
                <p
                  style={{
                    fontSize: "15px",
                    color: "#444",
                    marginTop: "15px",
                    marginBottom: "20px",
                  }}
                >
                  కొనుగోలు చేసిన ఉత్పత్తులు డౌన్లోడ్ కోసం డౌన్లోడ్స్ అందుబాటులో
                  ఉంటాయి. మీరు వాటిని మీ డౌన్లోడ్స్‌లో కనిపెట్టలేకపోతే, దయచేసి ఈ
                  సమస్యను WhatsApp ద్వారా నివేదించండి. అదే ఉత్పత్తులను మళ్లీ
                  కొనవద్దు.{" "}
                  <b>
                    కొనుగోలు చేసిన ఏదైనా డిజిటల్ వస్తువులకు రీఫండ్లు అందించబడవు.
                  </b>
                </p>
              </div>

              <div
                style={{
                  marginTop: "10px",
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: "10px",
                  flexWrap: "wrap",
                }}
              >
                <button
                  onClick={this.handleCancel}
                  style={{
                    padding: "10px 16px",
                    background: "#ccc",
                    border: "none",
                    borderRadius: "6px",
                    fontSize: "14px",
                    cursor: "pointer",
                    flex: "1 1 40%",
                    minWidth: "100px",
                  }}
                >
                  Cancel
                </button>
                <button
                  onClick={this.handleAgree}
                  style={{
                    padding: "10px 16px",
                    background:
                      "linear-gradient(to right, rgba(230, 92, 91, 0.9), rgba(245, 93, 44, 0.9))",
                    color: "#fff",
                    border: "none",
                    borderRadius: "6px",
                    fontSize: "14px",
                    fontWeight: "bold",
                    cursor: "pointer",
                    flex: "1 1 40%",
                    minWidth: "100px",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
                  }}
                >
                  Agree & Continue
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  cartItems: state.cart.cartItems,
});

const mapDispatchToProps = {
  incrementToCart,
  decreaseToCart,
  removeFromCart,
};

export default connect(mapStateToProps, mapDispatchToProps)(Cartsidebar);

